import { createContext } from "react";

export const readminPageContext = createContext({});
export const timeZoneContext = createContext();
export const formContext = createContext({});
export const dialogContext = createContext({
  isInDialog: false,
});

// Scopes useRouteState keys so sibling tabs don't read each other's filters.
export const routeStateNamespaceContext = createContext("");

export const readminSidebarContentContext = createContext();
export const readminSidebarItemContext = createContext({
  level: -1,
  items: [],
  ancestors: [],
});
